import React__default from 'react';
import classNames from 'classnames';
import Logo from '../Logo/Logo.js';
import styles from './Header.module.scss.js';
import Menu from '../HeaderMenu/Menu.js';
import Stack from '../../DataDisplay/Stack/Stack.js';
import Typography from '../../DataDisplay/Typography/Typography.js';
import '../../Forms/Checkbox/Checkbox.js';
import '../../DataDisplay/Table/Table.module.scss.js';
import '../../../styles/forms.css.js';
import '../Tooltip/Tooltip.js';
import '../../Forms/ButtonIcon/ButtonIcon.module.css.js';
import 'react-intersection-observer';
import '../../../node_modules/lodash/_baseClone.js';
import '../../DataDisplay/TextTruncate/TextTruncate.module.css.js';
import '../../../styles/fonts.css.js';
import '../../Forms/Button/Button.module.scss.js';
import Divider from '../Divider/Divider.js';

const Header = ({ template = 'web', title, subtitle, background = 'light', size = 'medium', hasSignOut = false, logoOnClick, menuSupportURL = '', customComponents = [], }) => {
    if (template === 'tableau') {
        let lines;
        if (subtitle) {
            lines = subtitle.split('%0A');
            //if (lines.length < 2) lines = subtitle.split('\\n');
        }
        return (React__default.createElement("div", { className: classNames(styles.Header, styles[`${background}`]) },
            React__default.createElement("div", { style: {
                    display: 'grid',
                    gridTemplateColumns: '4fr 1fr',
                    alignItems: 'center',
                } },
                React__default.createElement("div", null,
                    React__default.createElement("div", { style: {
                            fontFamily: 'Siemens',
                            fontSize: 22,
                            color: '#641e8c',
                            fontWeight: 'bold',
                        } }, title),
                    lines && (React__default.createElement("div", { style: { fontFamily: 'Siemens', fontSize: 16 - lines.length } }, lines.map((line, index) => (React__default.createElement(React__default.Fragment, { key: index },
                        line,
                        index !== lines.length - 1 && React__default.createElement("br", null))))))),
                React__default.createElement("div", { style: { textAlign: 'right' } },
                    React__default.createElement(Logo, { size: size, background: background, onClick: logoOnClick })))));
    }
    else {
        return (React__default.createElement("div", { className: classNames(styles.Header, styles[`${background}`]) },
            React__default.createElement(Logo, { size: size, background: background }),
            React__default.createElement("div", { style: { float: 'right' } },
                React__default.createElement(Stack, { direction: "row", horizontalAlign: "right", gap: 10 },
                    customComponents.map((node, index) => (React__default.createElement(React__default.Fragment, { key: index }, node))),
                    title && customComponents.length > 0 && (React__default.createElement(Divider, { orientation: "vertical" })),
                    React__default.createElement(Typography, { tag: "textdefault_strong", color: "#666666" }, title),
                    title && hasSignOut && React__default.createElement(Divider, { orientation: "vertical" }),
                    hasSignOut ? React__default.createElement(Menu, { supportURL: menuSupportURL }) : null))));
    }
};

export { Header as default };
//# sourceMappingURL=Header.js.map
